import { timeSpanRegex } from "@iventis/utilities";
import { EditorValidator } from "../types/data-table.types";

export const timeSpanValidator: EditorValidator = (_, __, value) => {
    const timeSpan = (value as unknown) as string;
    const match = timeSpan.match(timeSpanRegex);
    const doesFail = match == null;
    return {
        doesFail,
        errorMessage: "hh:mm:ss",
    };
};
